export const dailyDevo = {
  name: "dailydevo.ca",
  url: "https://dailydevo.ca",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_spirit-growth-log/artifacts/ormaiue7_DailyDevo%20Site%20Icon.png",
};